import {AfterViewInit, Component, OnInit} from '@angular/core';
import {AnalyticsService} from './components/analytics-service/analytics.service';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {
  title = 'aiheatlhlab-website';
  isLoaded = false;

  constructor(private analyticsService: AnalyticsService, private router: Router) {
    this.analyticsService.emitEvent(
      'Website visit',
      'Fresh visit'
    );
  }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isLoaded = true;
      console.log('app laoded');
      }, 2000);
  }
}
